export default {
  title: 'Impostazioni',
  reservation_hours_helper: 'Questi orari definiscono quando gli ospiti possono prenotare online.',
  reservation_hours_alert:
    'Gli orari di prenotazione differiscono dagli orari di apertura. Gli ospiti possono prenotare solo negli orari indicati qui.',
  activated: 'Prenotazioni attive',
  deactivated: 'Prenotazioni inattive',
  buttons: {
    activate: 'Attiva',
    deactivate: 'Disattiva',
  },
  error_messages: {
    no_google_place: {
      title: 'Il ristorante non è collegato a nessuna posizione Google',
      description: 'Collega il ristorante a una posizione Google',
    },
    toggle_failed: 'Impossibile aggiornare le prenotazioni. Riprova.',
  },
};
